export default "__VITE_ASSET__Bo5qj374__"